// extracted by mini-css-extract-plugin
export default {"breadcrumb-container":"Breadcrumbs_breadcrumb-container__rVe3w","active":"Breadcrumbs_active__Iay6Z"};